import React, { useState } from "react";
import { useNavigate, Navigate } from "react-router-dom";
import { Lock, ArrowRight } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";

export default function Login() {
  const { user, login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [submitting, setSubmitting] = useState(false);

  if (user && user.role === "admin") return <Navigate to="/admin" replace />;

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setSubmitting(true);
    const res = await login(email, password);
    setSubmitting(false);
    if (res.ok) navigate("/admin");
    else setError(res.error || "Login failed");
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-16" data-testid="login-page">
      <div className="w-full max-w-md">
        <div className="bg-[#13161C] border border-[#272E3A] p-8 lg:p-10">
          <div className="flex items-center gap-3 mb-8">
            <div className="w-10 h-10 bg-[#FF5500] flex items-center justify-center">
              <Lock className="w-5 h-5 text-black" strokeWidth={2.5} />
            </div>
            <div>
              <div className="overline">/admin — restricted</div>
              <h1 className="font-display font-black text-white text-2xl tracking-tight">Operator login</h1>
            </div>
          </div>

          <form onSubmit={submit} className="space-y-5">
            <div>
              <label className="block font-mono text-xs uppercase tracking-widest text-[#94A3B8] mb-2">Email</label>
              <input
                type="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                data-testid="login-email-input"
                className="w-full bg-[#0A0C10] border border-[#272E3A] focus:border-[#FF5500] focus:outline-none px-4 py-3 text-white font-mono text-sm transition-colors"
                placeholder="admin@example.com"
              />
            </div>
            <div>
              <label className="block font-mono text-xs uppercase tracking-widest text-[#94A3B8] mb-2">Password</label>
              <input
                type="password"
                required
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                data-testid="login-password-input"
                className="w-full bg-[#0A0C10] border border-[#272E3A] focus:border-[#FF5500] focus:outline-none px-4 py-3 text-white font-mono text-sm transition-colors"
                placeholder="••••••••"
              />
            </div>

            {error && (
              <div className="text-sm text-[#EF4444] border border-[#EF4444]/30 bg-[#EF4444]/10 px-4 py-3 font-mono" data-testid="login-error">
                {error}
              </div>
            )}

            <button
              type="submit"
              disabled={submitting}
              data-testid="login-submit-btn"
              className="w-full px-6 py-3 bg-[#FF5500] hover:bg-[#FF7326] disabled:opacity-50 text-white font-semibold transition-colors flex items-center justify-center gap-2"
            >
              {submitting ? "Authenticating..." : "Sign In"} <ArrowRight className="w-4 h-4" />
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
